/* import __COLOCATED_TEMPLATE__ from './user-selector.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent-2 */

import Component from '@glimmer/component';
import { action } from '@ember/object';
import type UserSummary from 'embercom/objects/inbox/user-summary';
import { MAX_USERNAME_LENGTH } from 'embercom/components/workflows/preview/preview-module';

export interface Args {
  selectedUser?: UserSummary;
  asNewLead?: boolean;
  onOpenUserSearch?: () => void;
  onSelectPreviewUser?: () => void;
}

interface Signature {
  Element: HTMLDivElement;
  Args: Args;
}

export default class UserSelector extends Component<Signature> {
  get isPreviewUserSelected() {
    return !this.args.selectedUser && !this.args.asNewLead;
  }

  get isSpecificUserSelected() {
    return Boolean(this.args.selectedUser) || Boolean(this.args.asNewLead);
  }

  get truncatedUserName(): string | undefined {
    let name = this.args.selectedUser?.displayAs;
    if (!name) {
      return undefined;
    }

    if (name.length <= MAX_USERNAME_LENGTH) {
      return name;
    }

    return `${name.slice(0, MAX_USERNAME_LENGTH)}...`;
  }

  @action
  selectUserOrLead(): void {
    this.args.onOpenUserSearch?.();
  }

  @action
  selectPreviewUser(): void {
    this.args.onSelectPreviewUser?.();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Impersonation::UserSelector': typeof UserSelector;
    'ai-agent/impersonation/user-selector': typeof UserSelector;
  }
}
